import { Route, Routes, HashRouter as Router } from 'react-router-dom'

import Public from '.'
import Campaign from './packs/Campaign'

const ClientRoutes = () => (
  <Router>
    <Public>
      <Routes>
        <Route path="/public/campaigns/:campaignId/*" element={<Campaign />} />
      </Routes>
    </Public>
  </Router>
)

export default ClientRoutes
